import { combineReducers } from 'redux';
import manageSideBar from './manageSideBar';
import attributeSetting from './attributeSetting'

export default combineReducers({
  manageSideBar,
  attributeSetting
});
